import { Scheme } from '@@/schemes/ts';

export const SCHEME2NUMBER_MAP = {
  [Scheme.Single]: 1,
  [Scheme.Pair]: 2,
  [Scheme.Sequence]: 3,
};
